<template>
  <div class="shoprenter-settings-view flex flex-col">
    <page-header :title="tr('Settings')" />

    <div class="flex max-w-2xl flex-col gap-5 py-5">
      <form-section :title="tr('Subscription')">
        <info-text v-if="hasChargeFailed" type="error">
          {{ tr('Subscription activation failed. Please try again.') }}
        </info-text>

        <template v-if="!company.current_subscription || company.current_subscription.package.is_free_trial">
          <p class="m-0 text-sm text-muted-foreground">
            {{ tr('You don\'t have an active subscription yet. To start using the service, please initiate a subscription.') }}
          </p>
          <ui-button class="self-start" :disabled="isLoading" @click="() => startSubscription()">
            <loader-circle-icon v-if="isLoading" class="animate-spin" />
            {{ tr('Start subscription') }}
          </ui-button>
        </template>

        <template v-else-if="company.has_shoprenter_charge">
          <p class="m-0 text-sm text-muted-foreground">
            {{ tr('Your subscription is active. If you cancel, you can still use the service until the end of the billing cycle you have already paid for.') }}
          </p>
          <ui-button variant="ghost" class="self-start text-destructive hover:text-destructive" @click="() => openCancelModal()">
            {{ tr('Cancel subscription') }}
          </ui-button>
        </template>

        <template v-else>
          <p class="m-0 text-sm text-muted-foreground">
            {{ tr('Your subscription cancellation is in progress. The subscription remains active and usable until the end of the paid billing cycle.') }}
          </p>
          <ui-button variant="ghost" class="self-start text-destructive" disabled>
            {{ tr('Cancel subscription') }}
          </ui-button>
        </template>
      </form-section>
    </div>
  </div>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

import ShoprenterService from '@/services/Shoprenter';
import CancelSubscriptionModal from '@/ui/components/CancelSubscriptionModal.vue';
import FormSection from '@/ui/components/FormSection.vue';
import InfoText from '@/ui/components/InfoText.vue';
import PageHeader from '@/ui/components/PageHeader.vue';

export default {
  name: 'ShoprenterSettingsView',
  components: {
    FormSection,
    InfoText,
    LoaderCircleIcon: LoaderCircle,
    PageHeader,
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    company() {
      return this.$root.currentCompany;
    },
    hasChargeFailed() {
      return this.$route.query.shoprenter_charge === 'failed';
    },
  },
  methods: {
    startSubscription() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      ShoprenterService.createCharge()
        .then(resp => {
          window.top.location.href = resp.confirmationUrl;
          return resp;
        })
        .catch(err => {
          this.isLoading = false;
          this.error(err);
        });
    },
    openCancelModal() {
      this.$fullscreenModal.open(this, CancelSubscriptionModal, {});
    },
  },
};
</script>
